import classNames from 'classnames'
import React from 'react'
import ValueCard from '../atoms/ValueCard'
import { CasesPages_Content_LogoBoxesInAGrid_Boxes } from '../content/types'

type Props = {
  items: CasesPages_Content_LogoBoxesInAGrid_Boxes[]
}

const LogoBox = ({ items }: Props) => {
  if (items.length === 0) {
    return <div></div>
  }

  const largeItems = !!items[0].subtitle

  const cls = classNames('grid grid-cols-2 gap-8', {
    'gap-x-4': !largeItems,
    'sm:grid-cols-3': items.length % 3 === 0 && !largeItems,
    'md:grid-cols-3': largeItems,
    'md:grid-cols-4': items.length % 4 === 0,
    'lg:grid-cols-4': !largeItems,
  })

  return (
    <div className={cls}>
      {items.map(({ image, ...props }, i) => {
        return <ValueCard key={i} icon={image} {...props} />
      })}
    </div>
  )
}

export default LogoBox
